















import { Component, Vue } from "vue-property-decorator";
import VServiceTaskTableCell from "./VServiceTaskTableCell.vue";

@Component({
  components: {
    VServiceTaskTableCell
  }
})
export default class VServiceTaskTableRowHeader extends Vue {}
